'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

interface ProfileContextValue {
  avatarUrl:        string | null;
  displayName:      string | null;
  setAvatarUrl:     (url: string | null) => void;
  setDisplayName:   (name: string | null) => void;
}

const ProfileContext = createContext<ProfileContextValue>({
  avatarUrl:      null,
  displayName:    null,
  setAvatarUrl:   () => {},
  setDisplayName: () => {},
});

export function ProfileProvider({ children }: { children: React.ReactNode }) {
  const [avatarUrl,   setAvatarUrl]   = useState<string | null>(null);
  const [displayName, setDisplayName] = useState<string | null>(null);

  const handleSetAvatarUrl   = useCallback((url: string | null) => setAvatarUrl(url),   []);
  const handleSetDisplayName = useCallback((n:   string | null) => setDisplayName(n),   []);

  return (
    <ProfileContext.Provider value={{ avatarUrl, displayName, setAvatarUrl: handleSetAvatarUrl, setDisplayName: handleSetDisplayName }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  return useContext(ProfileContext);
}
